import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Dialog, DialogType, DialogFooter } from '@fluentui/react';
import { Col, Row } from "react-bootstrap"
import { DefaultButton } from '@fluentui/react/lib/Button';
import { useGetMasterKpiById } from '../../../../hooks/services/sKPI/useOfMasterKpi';
import MasterKpiInfo from './MasterKpiInfo';

function ModalMasterKpi(props) {
    const { t } = useTranslation();
    
    const inputParam_MasterKpiId = props.masterKpiId !== null && props.masterKpiId !== undefined ? props.masterKpiId : null;
    const inputParam_IsModalOpen = props.isModalOpen !== null && props.isModalOpen !== undefined ? props.isModalOpen : null;
    const inputParam_HideModal = props.hideModal !== null && props.hideModal !== undefined ? props.hideModal : null;
    const inputParam_ListMeasurmentUnits = props.listMeasurmentUnits !== null && props.listMeasurmentUnits !== undefined ? props.listMeasurmentUnits : null;
    const inputParam_ListObjetives = props.listObjetives !== null && props.listObjetives !== undefined ? props.listObjetives : null;
    const [objMasterKpi, setObjMasterKpi] = useState(null);
    useGetMasterKpiById(inputParam_MasterKpiId, objMasterKpi, setObjMasterKpi, inputParam_IsModalOpen);


    //Render de componente.
    return (
            <Dialog
                hidden={!inputParam_IsModalOpen}
                onDismiss={inputParam_HideModal}
                minWidth={740}
                maxWidth={1300}
                dialogContentProps={{
                    type: DialogType.normal,
                    styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                    title: t('data-lang-lbl-masterkpi'),
                }}
                modalProps={{
                    isBlocking: true,
                }}
            >
                <Row className='pt-2'>
                    <Col>
                            {
                                objMasterKpi &&
                                <MasterKpiInfo
                                    objMasterKpi={objMasterKpi}
                                    showBoxBorder={false}
                                    listObjetives={inputParam_ListObjetives}
                                    listMeasurmentUnits={inputParam_ListMeasurmentUnits}
                                />
                            }
                    </Col>
                </Row>
                <DialogFooter>
                    <DefaultButton onClick={inputParam_HideModal} text={t('data-lang-btn-close')} />
                </DialogFooter>
            </Dialog>
        );
}
        
export default ModalMasterKpi;